// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ClickHeading_heading__rulRt {
  font-weight: normal;
  font-family: "VAGRounded", var(--fontFamily) !important;
  color: var(--foreground-color-1);
  margin-block-start: 0.75em;
  margin-block-end: 0.75em;
}
.ClickHeading_headingh1__KvQ9c {
  font-size: 2.75em;
}
.ClickHeading_headingh2__enS12 {
  font-size: 1.5em;
}
.ClickHeading_headingh3__7AH\\+P, .ClickHeading_headingh4__GKKv\\+ {
  font-size: 1.25em;
}
.ClickHeading_heading__rulRt span {
  text-shadow: 1px 1px 0 var(--background-color-3);
  color: var(--foreground-color-2);
}`, "",{"version":3,"sources":["webpack://./src/components/ClickHeading/ClickHeading.module.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,uDAAA;EACA,gCAAA;EAEA,0BAAA;EACA,wBAAA;AAAF;AACE;EACE,iBAAA;AACJ;AACE;EACE,gBAAA;AACJ;AACE;EAEE,iBAAA;AAAJ;AAEE;EACE,gDAAA;EACA,gCAAA;AAAJ","sourcesContent":[".heading {\n  font-weight: normal;\n  font-family: \"VAGRounded\", var(--fontFamily) !important;\n  color: var(--foreground-color-1);\n  // font-weight: var(--bold);\n  margin-block-start: 0.75em;\n  margin-block-end: 0.75em;\n  &h1 {\n    font-size: 2.75em;\n  }\n  &h2 {\n    font-size: 1.5em;\n  }\n  &h3,\n  &h4 {\n    font-size: 1.25em;\n  }\n  span {\n    text-shadow: 1px 1px 0 var(--background-color-3);\n    color: var(--foreground-color-2);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"heading": `ClickHeading_heading__rulRt`,
	"headingh1": `ClickHeading_headingh1__KvQ9c`,
	"headingh2": `ClickHeading_headingh2__enS12`,
	"headingh3": `ClickHeading_headingh3__7AH+P`,
	"headingh4": `ClickHeading_headingh4__GKKv+`
};
export default ___CSS_LOADER_EXPORT___;
